export default class AssessmentDriver {
    constructor(
        public driverFirstName: string,
        public driverLastName: string,
        public driverMobileNumber: string
    ) {}
}
